// @flow
import React, { Component } from 'react';
import { noop, isEmpty } from 'lodash';

import { hasAtLeastOnePrice } from 'Components/utils/price/price.util';

import { t } from 'Src/i18n';

import { Modal } from 'Components/frameworks/modal/Modal.jsx';
import { Price } from 'Components/frameworks/price/Price.jsx';
import {
  PricingTable,
  type PricingTableProps,
} from 'Components/frameworks/pricing-table/PricingTable.jsx';
import { themes } from './ProductFlag.themes';

const HEIGHT = '2.5rem';

export type ProductFlagProps = {
  className?: string,
  hasTransport?: boolean,
  isLinkDisabled?: boolean,
  onClick?: () => void,
  price: { [string]: * },
  pricingTable?: PricingTableProps,
  theme?: string,
  transportLabel?: string,
  isPriceLoading?: boolean,
};

type State = {
  isPackageVisible: boolean,
};

export class ProductFlag extends Component<ProductFlagProps, State> {
  static defaultProps = {
    hasTransport: false,
    isLinkDisabled: false,
    onClick: noop,
    price: {},
    theme: 'thumbnail',
    pricingTable: {},
    isPriceLoading: false,
  };

  constructor(props: ProductFlagProps) {
    super(props);

    this.state = {
      isPackageVisible: false,
    };
  }

  hasPrice() {
    const { price = {}, isPriceLoading } = this.props;
    return !isPriceLoading && (!!price.initialPrice || !!price.bestPrice);
  }

  togglePackage = () => {
    this.setState(prevState => ({
      isPackageVisible: !prevState.isPackageVisible,
    }));
  };

  onClick = () => {
    const { onClick = noop, isLinkDisabled } = this.props;

    if (!isLinkDisabled && !this.hasPrice()) {
      onClick();
    } else {
      this.togglePackage();
    }
  };

  render() {
    const { price, isPriceLoading, pricingTable = {}, onClick, theme } = this.props;
    const { thPriceFrom } = themes[theme];

    const pricingTableButton = { ...pricingTable.button, onClick };
    return !isEmpty(price) ? (
      <div style={{ height: HEIGHT }}>
        <button
          className="reset-button w-full whitespace-no-wrap"
          data-testid="ProductFlag-price"
          onClick={this.onClick}
          type="button"
        >
          <span className="flex items-center justify-end w-full">
            {hasAtLeastOnePrice(this.props.price) ? (
              <span className={thPriceFrom}>{price.from}</span>
            ) : null}
            <Price
              {...{ ...price, from: undefined }}
              className="flex items-center h-full rounded-tiny"
              isLoading={isPriceLoading}
              theme={theme}
            />
          </span>
          {this.state.isPackageVisible ? (
            <Modal
              ariaLabel={pricingTable.label}
              className="p-3"
              closeLabel={t('common.close')}
              onClose={e => {
                e.stopPropagation();
                this.togglePackage();
              }}
              size="auto"
            >
              <PricingTable {...pricingTable} button={pricingTableButton} />
            </Modal>
          ) : null}
        </button>
      </div>
    ) : null;
  }
}
